// src/features/cart/api/addToCart.js
import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useMutation } from 'react-query';
import { useNotificationStore } from 'stores/notifications';

export const addToCart = (data) => {
  return axios.post('/cart', data);
};

export const useAddToCart = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: addToCart,
    onSuccess: () => {
      queryClient.invalidateQueries('cart');
      addNotification({
        type: 'success',
        title: 'Item added to cart',
      });
    },
    onError: () => {
      addNotification({
        type: 'error',
        title: 'Add to cart failed',
        message: 'Could not add item to cart. Please try again.',
      });
    },
    ...config,
  });
};
